<template>
  <div>
    <div :class="$style.cookieSettings">
      <CookieSettingsItems v-model="cookieSettings" :items="itemsValues" :settings="cookieSettings" />
    </div>
    <div :class="[$style.cookieSettingsFooter, { [$style.sticky]: isFooterSticky }]" ref="cookieFooter">
      <div :class="$style.cookieSettingsButtons">
        <base-button @click="acceptAllCookie">Accept All Cookies</base-button>
        <base-button @click="saveSettings">Save Settings</base-button>
      </div>
      <p>
        You can withdraw your consent or manage your consent preferences at any time, via the links available in our
        <a href="/docs/privacy-policy">Privacy policy</a> or via the “Manage cookies” link at the footer of our website
        or you can disable cookies in the settings of their web-browser or mobile device.
      </p>
    </div>
  </div>
</template>

<script>
import itemsValues from './details-item-values.json';
import CookieSettingsItems from './CookieSettingsItems.vue';
import { BaseButton } from 'huntkit';
import { modalHelpers } from '~scripts/components/modals.js';

export default {
  name: 'CookieSettings',
  components: {
    CookieSettingsItems,
    BaseButton,
  },
  props: {
    cookieSettings: Object,
  },
  data() {
    return {
      itemsValues,
      isFooterSticky: false,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(([e]) => (this.isFooterSticky = e.intersectionRatio < 1), {
      threshold: [1],
    });

    observer.observe(this.$refs.cookieFooter);
  },
  methods: {
    closeModal() {
      const modal = document.getElementById('cookieAlertModalAi');
      if (modal.classList.contains('modal--open')) {
        modalHelpers.close(modal);
      }
    },
    saveSettings() {
      this.$emit('saveSettings');
      this.closeModal();
    },
    acceptAllCookie() {
      this.$emit('acceptAllCookie');
      this.closeModal();
    },
  },
};
</script>

<style module lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

.cookieSettings {
  padding: 2.4rem 2.4rem 2rem;
  border: 1px solid #e5e5e5;
  margin-top: 1.6rem;
  margin-bottom: 0.6rem;
  background: #fcfcfc;
  border-radius: 16px;

  @include mixins.media(md) {
    padding: 3.6rem 3rem;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
}

.cookieSettingsFooter {
  @include mixins.media(md) {
    position: sticky;
    bottom: -10px;
    background: #fff;
  }

  p {
    @include mixins.font(1.2rem, 1.45);

    color: #89898a;
    font-weight: vars.$fontWeightLight;
    letter-spacing: -0.005em;

    a {
      color: inherit;
      text-decoration: underline;

      @include mixins.hover {
        &:hover {
          color: #ffb800;
        }
      }
    }
  }
}

.cookieSettingsButtons {
  display: flex;
  flex-wrap: wrap;
  padding-top: 1rem;
  padding-bottom: 1.6rem;

  @include mixins.media(sm, max) {
    gap: 8px;
  }

  @include mixins.media(md) {
    flex-wrap: nowrap;
    padding-bottom: 2rem;
    gap: 10px;
  }

  button {
    width: 100%;
    height: unset;
    padding: 0.8rem 1.4rem;
    border-radius: 4px;
    line-height: 1.55;

    @include mixins.media(md) {
      @include mixins.font(1.8rem, 1.55);

      width: 50%;
    }
  }
}

.sticky {
  @include mixins.media(md) {
    border-top: 1px solid #e5e5e5;
  }
}
</style>
